// «Plataforma → Equipo Estateflow»: platform capabilities managed from the app (the bootstrap CLI is only needed for the
// first operator). Management routes require a platform super operator (`platformTeamAdmin`, isPlatformTeamAdmin);
// the invitation preview/accept routes are public auth routes authenticated by the emailed token.
import { z } from 'zod';
import { OkSchema } from './api.js';
import * as P from './api-platform-team.js';
import { IdParam, route } from './route-def.js';

export const platformTeamRoutes = {
  getPlatformTeam: route({
    method: 'GET', path: '/platform/team', summary: 'Equipo Estateflow: permisos de plataforma e invitaciones pendientes', tag: 'platform',
    platformTeamAdmin: true, response: P.PlatformTeamSchema,
  }),
  setPlatformCapabilities: route({
    method: 'PUT', path: '/platform/team/users/:userId/capabilities', summary: 'Reemplazar los permisos de plataforma de una persona (auditado)', tag: 'platform',
    platformTeamAdmin: true, params: z.object({ userId: IdParam }), body: P.SetPlatformCapabilitiesSchema, response: P.PlatformTeamMemberSchema,
  }),
  grantPlatformAccess: route({
    method: 'POST', path: '/platform/team/grants', summary: 'Dar permisos de plataforma por correo (cuenta existente) o invitar por correo', tag: 'platform',
    platformTeamAdmin: true, body: P.GrantPlatformAccessSchema, response: P.GrantPlatformAccessResultSchema,
  }),
  revokePlatformInvitation: route({
    method: 'DELETE', path: '/platform/team/invitations/:invitationId', summary: 'Revocar una invitación de plataforma pendiente', tag: 'platform',
    platformTeamAdmin: true, params: z.object({ invitationId: IdParam }), response: OkSchema,
  }),
  platformInvitationPreview: route({
    method: 'GET', path: '/auth/platform-invitations/:token', summary: 'Vista previa de invitación al equipo Estateflow', tag: 'auth',
    public: 'auth', params: z.object({ token: z.string().min(20).max(200) }), response: P.PlatformInvitationPreviewSchema,
  }),
  acceptPlatformInvitation: route({
    method: 'POST', path: '/auth/platform-invitations/accept', summary: 'Aceptar invitación al equipo Estateflow (crea cuenta o usa la sesión actual)', tag: 'auth',
    public: 'auth', body: P.AcceptPlatformInvitationRequestSchema, response: P.AcceptPlatformInvitationResponseSchema,
  }),
} as const;
